//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SectionAgencyLegalInformationAddress",
  props: {
    address: {
      type: String,
      default: () => ""
    }
  }
};
